import {TCreatePaymentInfoRequest} from "../../domain/repository/company_repository";

interface IGetCompanyByClientBillingRequest {
    // companyID: string;
}
class GetCompanyByClientBillingRequest implements IGetCompanyByClientBillingRequest {
    // public companyID: string;
}

interface ICreatePaymentInfoByClientBillingRequest {
    createPaymentInfoRequest?: TCreatePaymentInfoRequest
}
class CreatePaymentInfoByClientBillingRequest implements ICreatePaymentInfoByClientBillingRequest {
    public createPaymentInfoRequest: TCreatePaymentInfoRequest;
}

export {
    GetCompanyByClientBillingRequest,
    CreatePaymentInfoByClientBillingRequest
}


// WEBPACK FOOTER //
// ./src/presentation/request/company_request.ts